import './Marketplace.css';
import { getMagmicCoinPrice, sortTranscations } from './../../shared/assetHelpers';
import { useHistory } from 'react-router-dom';
import { useEffect, useState } from 'react';

import { ModalContainer } from '../../shared/components/modalContainer/ModalContainer';
import { MarketplaceBuyForm, MarketplaceDelistForm } from '../../shared/components/transactions/Transactions';
import Pet from '../../shared/components/pet/Pet';

import imageMagmicCoin from './../../images/magmic_coin.png';
import imageBackgroundWhiteGraphicsSquareLeft from './../../images/background_white_graphics_square_left_01.png';
import imageBackgroundWhiteGraphicsSquareRight from './../../images/background_white_graphics_square_right_01.png';

import { setDataRefreshRequestedDate } from './../../redux/ducks/user';
import { setAllMarketplaceAssets } from './../../redux/ducks/marketplace';
import { useSelector, useDispatch } from 'react-redux';

import { SignInModal, InsufficientMagmicCoinsModal } from '../../shared/components/user/User';

const amplifyModalId = "AmplifyProviderAuthenticator";


const Marketplace = () => {

  const history = useHistory();

  const [activeModals, setActiveModals] = useState({}); // add modals as a key/value, where the key is a unique id used to dismiss the modal and the value is what to render

  const [loading, setLocalLoading] = useState(true);
  //const [marketplaceArray, setMarketplaceArray] = useState([]);

  const userReduxStore = useSelector(state => {
    return state.user;
  });

  const marketplaceReduxStore = useSelector(state => {
    return state.marketplace;
  });

  const dispatch = useDispatch();


  const loadMarketplace = () => {
    setLocalLoading(true);
    // Simple GET request
    const requestOptions = {
      method: 'GET'
    };

    let apiEndpointURL = "";
    switch (process.env.REACT_APP_ENV) {
      case "staging":
        apiEndpointURL = "https://cf35m63tng.execute-api.us-east-1.amazonaws.com/test/marketplace/list";
        break;
      default:
        apiEndpointURL = "https://q645yqsbml.execute-api.us-east-1.amazonaws.com/prod/marketplace/list";
        break;
    }

    fetch(apiEndpointURL, requestOptions)
        .then(response => response.json())
        .then(data => {
          setLocalLoading(false);
          const transactions = data.response && data.response.transactions ? data.response.transactions : [];

          sortTranscations(transactions);

          dispatch(setAllMarketplaceAssets(transactions));
          //setMarketplaceArray(data.response && data.response.transactions ? data.response.transactions : []);
        });
  };
  
  const dismissAmplifySignInModal = () => {
    const activeModalsToEdit = activeModals;
    delete activeModalsToEdit[amplifyModalId];
    setActiveModals({...activeModalsToEdit}); // use spread operator to create a new object
  };

  useEffect(
    () => {
      dismissAmplifySignInModal();
      if (userReduxStore.loadComplete) {
        loadMarketplace();
      }
    },
    [userReduxStore.loadComplete] // run on redux user state updates
  );

  const promptToBuy = (marketplaceTransactionItem) => {

    const isSignedIn = userReduxStore.user && userReduxStore.user.attributes && userReduxStore.user.attributes.email ? true : false;

    if (!isSignedIn) {
      const activeModalsToUpdate = activeModals;

      activeModalsToUpdate[amplifyModalId] = <SignInModal
        title={"Magmic Core Sign In"}
        onDismiss={dismissAmplifySignInModal}
      />;
      setActiveModals({...activeModalsToUpdate});
      return;
    }

    if (!userReduxStore.forteData.id) {
      history.push("/wallet/fortelink");
      return;
    }

    const modalId = "marketplacePromptToBuy";
    const petName = marketplaceTransactionItem.pet ? marketplaceTransactionItem.pet.name : undefined;
    const priceMC = getMagmicCoinPrice(marketplaceTransactionItem);

    if (!petName || !priceMC) {
      console.error("Marketplace promptToBuy marketplaceTransactionItem invalid pet or pet name or fullPrice");
      return;
    }

    if (userReduxStore.magmicCoin === undefined) {
      console.error("Marketplace promptToBuy userReduxStore missing magmicCoin property");
      return;
    }

    const activeModalsToUpdate = activeModals;

    if (userReduxStore.magmicCoin <= parseInt(marketplaceTransactionItem.fullPrice, 10)) {
      activeModalsToUpdate[modalId] = <InsufficientMagmicCoinsModal
        title={"Buy " + petName}
        onDismiss={() => {
          const activeModalsToEdit = activeModals;
          delete activeModalsToEdit[modalId];
          setActiveModals({...activeModalsToEdit}); // use spread operator to create a new object
        }}
        assetName={petName}
      />
      setActiveModals({...activeModalsToUpdate});
      return;
    }

    const onDismiss = () => {
      const activeModalsToEdit = activeModals;
      delete activeModalsToEdit[modalId];
      setActiveModals({...activeModalsToEdit}); // use spread operator to create a new object
    };

    const onSuccess = () => {
      dispatch(setDataRefreshRequestedDate(new Date())); // trigger an App.useEffect user refresh
      loadMarketplace();
      onDismiss();
    };

    activeModalsToUpdate[modalId] = <ModalContainer
      title={"Buy " + marketplaceTransactionItem.pet.name}
      smallPromptFormat={true}
      hideHeaderDismissButton={true}
      onDismiss={onDismiss}
    >
      <MarketplaceBuyForm
        marketplaceTransactionItem={marketplaceTransactionItem}
        onDismiss={onDismiss}
        onSuccess={onSuccess}
      />
    </ModalContainer>
    setActiveModals({...activeModalsToUpdate});
  };

  const promptToDelist = (marketplaceTransactionItem) => {

    const modalId = "marketplacePromptToDelist";
    const asset = marketplaceTransactionItem.pet;

    const activeModalsToUpdate = activeModals;

    const onDismiss = () => {
      const activeModalsToEdit = activeModals;
      delete activeModalsToEdit[modalId];
      setActiveModals({...activeModalsToEdit}); // use spread operator to create a new object
    };

    const onSuccess = () => {
      dispatch(setDataRefreshRequestedDate(new Date())); // trigger an App.useEffect user refresh
      loadMarketplace();
      onDismiss();
    };

    activeModalsToUpdate[modalId] = <ModalContainer
      title={"Delist " + asset.name}
      smallPromptFormat={true}
      hideHeaderDismissButton={true}
      onDismiss={onDismiss}
    >
      <MarketplaceDelistForm
        asset={asset}
        marketplaceTransactionItem={marketplaceTransactionItem}
        onDismiss={onDismiss}
        onSuccess={onSuccess}
      />
    </ModalContainer>
    setActiveModals({...activeModalsToUpdate});
  };

  return (
    <div className="marketplace">
      {Object.keys(activeModals).map( (modalId) => {
        return activeModals[modalId]
      })}
      <header className="sectionLanding">
        <div className="marketplaceSectionBackgroundLeft"><img src={imageBackgroundWhiteGraphicsSquareLeft} /></div>
        <div className="marketplaceSectionBackgroundRight"><img src={imageBackgroundWhiteGraphicsSquareRight} /></div>
        <div className="sectionLandingContentWrapper">
          <div className="sectionLandingLeft">
            <h1>
              Marketplace
            </h1>
          </div>
          <div className="sectionLandingRight">
          </div>
        </div>
      </header>
      <div className="sectionSeparator sharp"></div>
      {loading ?
        <div className="sectionWrapper">
          <section className="marketplaceSection">
            <div className="marketplaceResults loadingContainer">
            </div>
          </section>
        </div>
      :
        <div className="sectionWrapper">
          <section className="marketplaceSection">
            <div className="marketplaceResults">
              {marketplaceReduxStore.assets.map((transaction) => {
                let priceMC = getMagmicCoinPrice(transaction);
                return (
                  <div className="assetSummary" key={transaction.id}>
                      <div className="assetSummarySeparatorVertical"></div>
                      <div className="assetSummaryContentWrapper">
                      <Pet pet={transaction.pet} parentComponentExtendedContent={
                        <>
                          <div className="price">
                            <span className="total">
                              {priceMC}
                            </span>
                            <span className="currency">
                              <img src={imageMagmicCoin} />
                            </span>
                          </div>
                          <div className="actions">
                            {transaction.sellerInfo !== undefined && userReduxStore.forteData.id !== undefined ?
                              <>
                                {userReduxStore.forteData.id === transaction.sellerInfo.forteId ?
                                  <button className="delist" onClick={() => {
                                    promptToDelist(transaction);
                                  }}>
                                    Delist
                                  </button>
                                :
                                  <button className="buy" onClick={() => {
                                    promptToBuy(transaction);
                                  }}>
                                    Buy
                                  </button>
                                }
                              </>
                            :
                              <button className="buy" onClick={() => {
                                promptToBuy(transaction);
                              }}>
                                Buy
                              </button>
                            }
                          </div>
                        </>
                      }/>
                    </div>
                  </div>
                )
              })}
            </div>
          </section>
        </div>
      }
    </div>
  );
}

export default Marketplace;